<div class="sq card-body">
  <!-- <button
    (click)="closeManifest2()"
    type="button"
    class="close"
    style="position: relative"
    data-dismiss="modal"
    aria-label="Close"
  >
    <span aria-hidden="true">&times;</span>
  </button> -->

  <!-- 
  <div
    style="
      position: absolute;
      top: 1px;
      right: 0px;
      z-index: 99999;
      cursor: pointer;
    "
    mat-button
    (click)="closeManifest2()"
    class=""
    cdkFocusInitial
  >
    <i class="material-icons">close</i>
  </div> -->
  <!--  New Version of Manifest Hector -->
  <h2 class="d-flex justify-content-center">
    <b style="font-size: 18px"> Create New Batch</b>
  </h2>
  <mat-stepper [linear]="pobuscador" #stepper>
    <mat-step label="Container Type" [completed]="statusContainer">
      <div>
        <div class="">
          <!-- <h2 style="text-align: center; font-size: 2rem">
          Please select a container type
        </h2> -->
          <!-- <hr /> -->

          <div
            style="padding: 15px"
            class="containerCard d-flex justify-content-center"
          >
            <div *ngFor="let containerType of containersType">
              <div
                class="cardimagen"
                [ngClass]="[
                  statusContainer == containerType.name
                    ? 'card-imagen-selected'
                    : ''
                ]"
                (click)="selectContainerType(containerType.name)"
              >
                <img [src]="containerType.icon" width="100" height="100" />
                <br />
                <span> {{ containerType.name }}</span>
              </div>
            </div>
            <!-- <div
            *ngFor="let containerType of containersType"
            (click)="selectContainerType(containerType.name)"
            class="card"
            style="width: 10rem; margin-right: 20px; cursor: pointer"
          >
            <div class="card-body card-bodymanifest text-center">
              <h5 class="card-title titlebox">
                {{ containerType.name }}
              </h5>
              <span class="material-icons iconbox">
                {{ containerType.icon }}
              </span>
            </div>
          </div> -->
          </div>
        </div>
      </div>
      <div class="d-flex mt-4">
        <button
          class="gts-btn-primary-outline mr-2"
          matRipple
          (click)="closeBatch()"
          *ngIf="cancel"
        >
          <span class="gts-btn-icon-left">close</span
          ><span class="gts-btn-text">Cancel</span>
        </button>
        <button
          class="gts-btn-primary-outline"
          matRipple
          matStepperNext
          [disabled]="!statusContainer"
        >
          <span class="gts-btn-icon-left">east</span
          ><span class="gts-btn-text">Next</span>
        </button>
      </div>
    </mat-step>
    <mat-step label="Content Type" [completed]="statusContent">
      <div>
        <div>
          <!-- <h2 style="text-align: center; font-size: 2rem">
          Please select content type
        </h2> -->
          <!-- <hr /> -->
          <div class="containerCard d-flex justify-content-center">
            <div *ngFor="let containerType of contentType">
              <div
                class="cardimagen"
                [ngClass]="[
                  this.statusContent == containerType.name
                    ? 'card-imagen-selected'
                    : ''
                ]"
                (click)="selectContentType(containerType.name)"
              >
                <img [src]="containerType.icon" width="100" height="100" />
                <br />
                <span> {{ containerType.name }}</span>
              </div>
            </div>
            <!-- <div *ngFor="let containerType of contentType" class="col-md-6">
            <div
              (click)="selectContentType(containerType.name)"
              class="card"
              style="
                width: 18rem;
                margin-right: 20px;
                margin: 0 auto;
                cursor: pointer;
              "
            >
              <div class="card-body card-bodymanifest text-center">
                <h5 class="card-title titlebox">
                  {{ containerType.name }}
                </h5>
                <span class="material-icons iconbox">
                  {{ containerType.icon }}
                </span>
              </div>
            </div>
          </div> -->
          </div>
        </div>
      </div>
      <div class="d-flex mt-4">
        <button
          class="gts-btn-primary-outline mr-2"
          matRipple
          (click)="closeBatch()"
          *ngIf="cancel"
        >
          <span class="gts-btn-icon-left">close</span
          ><span class="gts-btn-text">Cancel</span>
        </button>
        <button
          class="gts-btn-primary-outline mr-2"
          matRipple
          matStepperPrevious
        >
          <span class="gts-btn-icon-left">west</span
          ><span class="gts-btn-text">Previous</span>
        </button>
        <button
          class="gts-btn-primary-outline"
          matRipple
          matStepperNext
          [disabled]="!statusContent"
        >
          <span class="gts-btn-icon-left">east</span
          ><span class="gts-btn-text">Next</span>
        </button>
      </div>
    </mat-step>
    <mat-step label="Batch Info">
      <div>
        <!-- <hr /> -->

        <form #f="ngForm" (keydown.enter)="$event.preventDefault()">
          <div *ngIf="newContentType == 'HDD/SSD'">
            <div>
              <mat-form-field class="example-full-width has-label">
                <mat-label for="caddiesForm"
                  >Do the drives have caddies?</mat-label
                >
                <mat-select
                  name="caddiesForm"
                  id="caddiesForm"
                  [(ngModel)]="caddies"
                  (change)="changecaddies($e)"
                  required
                >
                  <mat-option value="">Please select an option</mat-option>
                  <mat-option value="YesALL">Yes - All</mat-option>
                  <mat-option value="YesSome">Yes - Some</mat-option>
                  <mat-option value="No">No</mat-option>
                </mat-select>
              </mat-form-field>
              <!-- <mat-form-field class="example-full-width has-label">
                <mat-label for="batchPriorityForm"
                  >Batch Priority Level</mat-label
                >
                <mat-select
                  name="batchPriorityForm"
                  id="batchPriorityForm"
                  [(ngModel)]="batchPriorityLevel"
                >
                  <mat-option value="">Please select an option</mat-option>
                  <mat-option value="Low Priority">Low Priority</mat-option>
                  <mat-option value="Medium Priority"
                    >Medium Priority</mat-option
                  >
                  <mat-option value="Fast Priority">Fast Priority</mat-option>
                  <mat-option value="Urgent Priority"
                    >Urgent Priority</mat-option
                  >
                </mat-select>
              </mat-form-field> -->
            </div>

            <div>
              <mat-form-field class="example-full-width has-label">
                <mat-label> Quantity of HDD?</mat-label>
                <input
                  type="number"
                  min="0"
                  (keypress)="mtds.onlyNumber($event)"
                  name="hdd_qty"
                  [(ngModel)]="hardDrives"
                  matInput
                  [disabled]="newContentType != 'HDD/SSD'"
                />
              </mat-form-field>
              <mat-form-field class="example-full-width has-label">
                <mat-label> Quantity of SSD?</mat-label>
                <input
                  type="number"
                  min="0"
                  (keypress)="mtds.onlyNumber($event)"
                  name="ssd_qty"
                  [(ngModel)]="ssd"
                  matInput
                  [disabled]="newContentType != 'HDD/SSD'"
                />
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="newContentType == 'Devices'">
            <!-- <mat-form-field style="width: 100%" class="form-group">
              <mat-label for="batchPriorityForm"
                >Batch Priority Level</mat-label
              >
              <mat-select
                name="batchPriorityForm"
                id="batchPriorityForm"
                #batchPriorityForm="ngModel"
                [(ngModel)]="batchPriorityLevel"
              >
                <mat-option value="">Please select an option</mat-option>
                <mat-option value="Low Priority">Low Priority</mat-option>
                <mat-option value="Medium Priority">Medium Priority</mat-option>
                <mat-option value="Fast Priority">Fast Priority</mat-option>
                <mat-option value="Urgent Priority">Urgent Priority</mat-option>
              </mat-select>
            </mat-form-field> -->
            <div>
              <div style="width: 100%">
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Quantity of Desktops?</mat-label>
                  <input
                    type="number"
                    min="0"
                    (keypress)="mtds.onlyNumber($event)"
                    name="hdd_qty"
                    [(ngModel)]="desktops"
                    matInput
                    [disabled]="newContentType == 'HDD/SSD'"
                  />
                </mat-form-field>
              </div>
              <div style="width: 100%" class="form-group w-100">
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Quantity of All in One?</mat-label>
                  <input
                    type="number"
                    min="0"
                    (keypress)="mtds.onlyNumber($event)"
                    name="ssd_qty"
                    [(ngModel)]="allInOne"
                    matInput
                    [disabled]="newContentType == 'HDD/SSD'"
                  />
                </mat-form-field>
              </div>
              <div style="width: 100%" class="form-group w-100">
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Quantity of Laptops?</mat-label>
                  <input
                    type="number"
                    min="0"
                    (keypress)="mtds.onlyNumber($event)"
                    name="ssd_qty"
                    [(ngModel)]="laptops"
                    matInput
                    [disabled]="newContentType == 'HDD/SSD'"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div *ngIf="newContentType == 'Mobile Devices'">
            <div class="d-flex">
              <!-- <div
              style="width: 100%; padding-left: 0"
              class="col-md-6 form-group w-100 mr-3"
            >
              <label style="margin-top: 22px" for="batchPriorityForm"
                >Batch Priority Level</label
              >
              <select
                name="batchPriorityForm"
                id="batchPriorityForm"
                #batchPriorityForm="ngModel"
                [(ngModel)]="batchPriorityLevel"
                class="form-control"
              >
                <option value="">Please select an option</option>
                <option value="Low Priority">Low Priority</option>
                <option value="Medium Priority">Medium Priority</option>
                <option value="Fast Priority">Fast Priority</option>
                <option value="Urgent Priority">Urgent Priority</option>
              </select>
            </div> -->
              <div style="width: 100%" class="form-group w-100 mr-3">
                <mat-form-field class="example-full-width has-label">
                  <mat-label> Quantity of Mobile Devices?</mat-label>
                  <input
                    type="number"
                    min="0"
                    (keypress)="mtds.onlyNumber($event)"
                    name="mobiledevices_qty"
                    [(ngModel)]="mobileDevices"
                    matInput
                  />
                </mat-form-field>
              </div>
            </div>
          </div>

          <div>
            <div>
              <mat-form-field class="example-full-width has-label">
                <mat-label> Total Weight (Lbs)</mat-label>
                <input
                  type="number"
                  min="0.00"
                  step="1"
                  placeholder="00.00"
                  name="totalWeightForm"
                  [(ngModel)]="newcontainerWeight"
                  (change)="sumarPesoNewContainer()"
                  matInput
                  required
                />
              </mat-form-field>
              <mat-form-field class="example-full-width has-label">
                <mat-label>NET Weight (Lbs)</mat-label>
                <input
                  type="number"
                  min="0.01"
                  step="0.01"
                  class="form-control currency"
                  placeholder="00.00"
                  name="totalNetWeightForm"
                  [(ngModel)]="newcontainerTotalNetWeight"
                  disabled
                  matInput
                />
              </mat-form-field>
              <!-- <div class="form-group w-100 mr-3">
              <label>Total Weight (Lbs)</label>
              <input
                type="number"
                min="0.00"
                step="1"
                placeholder="00.00"
                name="totalWeightForm"
                [(ngModel)]="newcontainerWeight"
                (change)="sumarPesoNewContainer()"
                required
              />
            </div> -->
              <!-- <div class="form-group w-100">
              <label>NET Weight (Lbs)</label>
              <input
                type="number"
                min="0.01"
                step="0.01"
                class="form-control currency"
                placeholder="00.00"
                name="totalNetWeightForm"
                [(ngModel)]="newcontainerTotalNetWeight"
                disabled
              />
            </div> -->
            </div>
            <div class="d-flex align-items-center" *ngIf="newcontainerWeight">
              <!-- <label *ngIf="loadingLocationsNewContainer"
              >Location <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
            ></label> -->
              <!-- <app-loading *ngIf=""></app-loading> -->
              <mat-progress-bar
                style="width: 100%"
                *ngIf="loadingLocationsNewContainer"
                id="loadingbar"
                mode="indeterminate"
              >
              </mat-progress-bar>
              <app-filter-object
                class="w-100"
                *ngIf="!loadingLocationsNewContainer"
                [options]="locationsListNewContainer"
                placeholder="Locations"
                [value]="newcontainerInternallocation_id"
                (selectChange)="changeLocationNewContainer($event)"
                [disabled]="locationsListNewContainer.length == 0"
              >
              </app-filter-object>

              <mat-checkbox
                style="width: 25%"
                (change)="onCheckboxChange($event)"
                >Show External Locations</mat-checkbox
              >
            </div>

            <!-- <div class="row">
            <div class="col-md-12">
              <label *ngIf="loadingUsers"
                >Loading Users <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
              ></label>

              <app-filter-object
                *ngIf="!loadingUsers"
                [options]="usersList"
                placeholder="Assign User"
                [value]="assignTo"
                (selectChange)="assignTo = $event.id"
              >
              </app-filter-object>
            </div>
          </div> -->

            <!-- <div
            *ngIf="
              newcontainerInternallocation_id != null &&
              newcontainerInternallocation_id != 0
            "
            class="comentarios-batch row"
          >
            <app-comments
              style="width: 100%"
              [id_phather]="idmanifestSelected"
              type_chat="BATCH"
              type_notification=""
              (receive_item_id)="receive_chatitem_id($event)"
              [item]="{
                caddies: caddies,
                hardDrives: hardDrives,
                ssd: ssd,
                desktops: desktops,
                allInOne: allInOne,
                laptops: laptops,
                newcontainerWeight: newcontainerWeight,
                newcontainerTotalNetWeight: newcontainerTotalNetWeight,
                newcontainerInternallocation_id:
                  newcontainerInternallocation_id,
                processing_instruction_id: item.po.id,
                newContentType: newContentType,
                newContainerType: newContainerType
              }"
              [disabled]="false"
            ></app-comments>
          </div> -->

            <div class="d-flex">
              <button
                class="gts-btn-primary-outline mr-2"
                matRipple
                (click)="closeBatch()"
                *ngIf="cancel"
              >
                <span class="gts-btn-icon-left">close</span
                ><span class="gts-btn-text">Cancel</span>
              </button>
              <button
                class="gts-btn-primary-outline mr-2"
                matRipple
                matStepperPrevious
              >
                <span class="gts-btn-icon-left">west</span
                ><span class="gts-btn-text">Previous</span>
              </button>
              <button
                [disabled]="isButtonDisabled()"
                class="gts-btn-primary"
                (click)="saveManifestNew()"
              >
                <span class="gts-btn-text"> Create Batch</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </mat-step>

    <!-- <mat-step>
      <ng-template matStepLabel>Done</ng-template>
      <p>You are now done.</p>
      <div></div>
    </mat-step> -->
    <div class="d-flex align-items-center">
      <!-- <button (click)="closeManifest2()" class="btn btn-danger mr-4">
          Cancel
        </button> -->
      <!-- <button
        *ngIf="newManifest2_step == 1 && data.poNumber == undefined"
        class="gts-btn-primary-outline d-flex align-items-center"
        [disabled]="!pobuscador || !selectedPoOption"
        matStepperNext
        matRipple
      >
        Next
        <i class="material-icons">navigate_next</i>
      </button>
      <button
        *ngIf="newManifest2_step == 1 && data.poNumber != undefined"
        (click)="changeStep()"
        class="gts-btn-primary-outline d-flex align-items-center"
        [disabled]="data.poNumber == undefined"
      >
        Next
        <i class="material-icons">navigate_next</i>
      </button> -->
    </div>
  </mat-stepper>

  <div>
    <!-- setp 0 -->

    <!-- setp 1 -->

    <!-- setp 2 -->

    <!-- step 3 -->
  </div>
  <!--  New Version of Manifest Hector -->

  <div *ngIf="!newManifest2" style="text-align: center">
    <app-progress
      style="width: 100%"
      *ngIf="action == 'read'"
      [po]="item.po.name"
      [step]="step"
      [itemsOnDepartament]="itemsOnDepartament"
      (newstep)="cambiarestatus($event)"
    ></app-progress>
  </div>
  <div
    *ngIf="
      action != 'create' &&
      deletManiest_id == null &&
      !erasure &&
      !changeStatus &&
      asignar == ''
    "
    style="width: 100%; position: relative"
  ></div>
  <div>
    <div class="" *ngIf="cargandoBatch" style="text-align: center">
      <h2>
        <b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b>
      </h2>
    </div>
    <div
      class=""
      *ngIf="
        !newManifest2 &&
        ((itemsManifest && itemsManifest.length) ||
          (itemsManifestNew && itemsManifestNew.length))
      "
    >
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <a
                class="btn btn-link btn-block text-left"
                style="color: black; font-size: 15px"
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                (click)="showhide = !showhide"
              >
                <span class="material-icons">
                  {{ showhide ? "visibility" : "visibility_off" }}
                </span>
                {{ showhide ? "Show" : "Hide" }}
              </a>
            </h2>
          </div>

          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionExample"
          >
            <div
              class="card-body"
              [ngStyle]="{
                height: itemsManifest.length >= 4 ? '700px' : 'auto',
                'overflow-y': itemsManifest.length >= 4 ? 'scroll' : 'hidden'
              }"
            >
              <div
                *ngFor="let item of itemsManifest"
                style="position: relative; margin-bottom: 25px"
              >
                <div class="esferas d-flex justify-content-between">
                  <div class="liner"></div>
                  <label>#{{ item.batch }}</label>
                  <div class="bde-container">
                    <div class="g1">
                      <button
                        type="button"
                        [ngClass]="[
                          item.hardDrivesDone == '1'
                            ? 'bde-active'
                            : 'clk bde-inactive'
                        ]"
                        class="icon-button"
                        (click)="
                          item.hardDrivesDone == '1'
                            ? finished(
                                'HARDDRIVES',
                                item.id,
                                item.hardDrivesDone,
                                false
                              )
                            : finished(
                                'HARDDRIVES',
                                item.id,
                                item.hardDrivesDone,
                                true
                              )
                        "
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Completed by {{ item.repNameHardDrives }}"
                        style="cursor: pointer"
                      >
                        <span class="material-icons">disc_full</span>
                        <span
                          *ngIf="item.hardDrives > 0"
                          class="badge top-right"
                          >{{ item.hardDrives }}</span
                        >
                      </button>
                    </div>
                    <label>Hard Drives</label>
                  </div>
                  <div class="bde-container">
                    <div class="g1">
                      <button
                        type="button"
                        [ngClass]="[
                          item.laptopsDone == '1'
                            ? 'bde-active'
                            : 'clk bde-inactive'
                        ]"
                        class="icon-button"
                        (click)="
                          item.laptopsDone == '1'
                            ? finished(
                                'LAPTOPS',
                                item.id,
                                item.laptopsDone,
                                false
                              )
                            : finished(
                                'LAPTOPS',
                                item.id,
                                item.laptopsDone,
                                true
                              )
                        "
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Completed by {{ item.repNameLaptops }}"
                        style="cursor: pointer"
                      >
                        <span class="material-icons">laptop</span>
                        <span
                          *ngIf="item.laptops > 0"
                          class="badge top-right"
                          >{{ item.laptops }}</span
                        >
                      </button>
                    </div>
                    <label>Laptops</label>
                  </div>
                  <div class="bde-container">
                    <div class="g1">
                      <button
                        type="button"
                        [ngClass]="[
                          item.desktopsDone == '1'
                            ? 'bde-active'
                            : 'clk bde-inactive'
                        ]"
                        class="icon-button"
                        (click)="
                          item.desktopsDone == '1'
                            ? finished(
                                'DESKTOPS',
                                item.id,
                                item.desktopsDone,
                                false
                              )
                            : finished(
                                'DESKTOPS',
                                item.id,
                                item.desktopsDone,
                                true
                              )
                        "
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Completed by {{ item.repNameDesktops }}"
                        style="cursor: pointer"
                      >
                        <span class="material-icons">desktop_windows</span>
                        <span
                          *ngIf="item.desktops > 0"
                          class="badge top-right"
                          >{{ item.desktops }}</span
                        >
                      </button>
                    </div>
                    <label>Desktops</label>
                  </div>
                  <div class="bde-container">
                    <div class="g1">
                      <button
                        type="button"
                        [ngClass]="[
                          item.allinoneDone == '1'
                            ? 'bde-active'
                            : 'clk bde-inactive'
                        ]"
                        class="icon-button"
                        (click)="
                          item.allinoneDone == '1'
                            ? finished(
                                'ALLINONE',
                                item.id,
                                item.allinoneDone,
                                false
                              )
                            : finished(
                                'ALLINONE',
                                item.id,
                                item.allinoneDone,
                                true
                              )
                        "
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Completed by {{ item.repNameAllInOne }}"
                        style="cursor: pointer"
                      >
                        <span class="material-icons">devices</span>
                        <span
                          *ngIf="item.allInOne > 0"
                          class="badge top-right"
                          >{{ item.allInOne }}</span
                        >
                      </button>
                    </div>
                    <label>All In One</label>
                  </div>
                  <div class="bde-container">
                    <div class="g1">
                      <button
                        type="button"
                        [ngClass]="[
                          item.containersDone == '1'
                            ? 'bde-active'
                            : 'clk bde-inactive'
                        ]"
                        class="icon-button"
                        (click)="
                          item.containersDone == '1'
                            ? finished(
                                'CONTAINERS',
                                item.id,
                                item.containersDone,
                                false
                              )
                            : finished(
                                'CONTAINERS',
                                item.id,
                                item.containersDone,
                                true
                              )
                        "
                      >
                        <span class="material-icons">storage</span>
                        <span
                          *ngIf="item.containers > 0"
                          class="badge top-right"
                          >{{ item.containers }}</span
                        >
                      </button>
                    </div>
                    <label>Containers for HDD?</label>
                  </div>
                  <div class="bde-container">
                    <div class="g1">
                      <button
                        type="button"
                        [ngClass]="[
                          item.containersDevicesDone == '1'
                            ? 'bde-active'
                            : 'clk bde-inactive'
                        ]"
                        class="icon-button"
                        (click)="
                          item.containersDevicesDone == '1'
                            ? finished(
                                'CONTAINERSDEVICES',
                                item.id,
                                item.containersDevicesDone,
                                false
                              )
                            : finished(
                                'CONTAINERSDEVICES',
                                item.id,
                                item.containersDevicesDone,
                                true
                              )
                        "
                      >
                        <span class="material-icons">storage</span>
                        <span
                          *ngIf="item.containersDevices > 0"
                          class="badge top-right"
                          >{{ item.containersDevices }}</span
                        >
                      </button>
                    </div>
                    <label>Containers for Devices?</label>
                  </div>
                  <div class="bde-container">
                    <div class="g1">
                      <button
                        type="button"
                        [ngClass]="[
                          item.laptopsDone === 1 &&
                          item.hardDrivesDone === 1 &&
                          item.desktopsDone === 1 &&
                          item.allinoneDone === 1
                            ? 'bde-active'
                            : 'bde-inactive'
                        ]"
                        class="icon-button"
                        (click)="log(item)"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Completed by {{ item.repNameBatchDone }}"
                        style="cursor: pointer"
                      >
                        <span class="material-icons">done</span>
                      </button>
                    </div>
                    <label>Complete</label>
                  </div>
                </div>
                <div class="d-flex justify-content-end mt-2 mb-4">
                  <i
                    style="cursor: pointer; color: rgba(26, 187, 199, 0.795)"
                    class="material-icons btn-link btn-just-icon"
                    (click)="splitItem(item)"
                    *ngIf="
                      item.laptopsDone !== 1 ||
                      item.hardDrivesDone !== 1 ||
                      item.desktopsDone !== 1 ||
                      item.allinoneDone !== 1
                    "
                    >call_split</i
                  >
                  <!-- &nbsp; -->
                  <i
                    style="cursor: pointer; color: rgba(26, 187, 199, 0.795)"
                    class="material-icons btn-link btn-just-icon"
                    (click)="showItemManifest(item)"
                    >remove_red_eye</i
                  >
                  <!-- &nbsp; -->
                  <i
                    style="cursor: pointer; color: black"
                    class="material-icons btn-link btn-just-icon"
                    (click)="printItemManifest(item)"
                    >local_printshop</i
                  >
                  <!-- &nbsp; -->
                  <i
                    style="cursor: pointer; color: red"
                    class="material-icons btn-link btn-just-icon"
                    (click)="deletManiest_id = item.id"
                    >delete_forever</i
                  >
                </div>
              </div>

              <!-- New Manifest Version Hector -->
              <div class="row" style="position: relative; margin-bottom: 25px">
                <div class="col-md-12">
                  <h3 class="text-center">Batch Containers</h3>
                  <div style="justify-content: center" class="row text-center">
                    <div class="col-md-3 col-sm-4">
                      <button
                        (click)="filtrarMI('ALL')"
                        mat-raised-button
                        style="color: black"
                        class="btn btn-link btn-dark"
                        [ngClass]="{
                          borderselected: filtroMI == 'ALL'
                        }"
                      >
                        <span class="material-icons"> inbox </span> All ·
                        {{ granTotalMI }}
                      </button>
                    </div>
                    <div class="col-md-3 col-sm-4">
                      <button
                        (click)="filtrarMI('Pending')"
                        mat-raised-button
                        class="btn btn-link btn-danger"
                        [ngClass]="{
                          borderselected: filtroMI == 'Pending'
                        }"
                      >
                        <span class="material-icons"> inbox </span>
                        Pending · {{ cant_pending }}
                      </button>
                    </div>
                    <div class="col-md-3 col-sm-4">
                      <button
                        (click)="filtrarMI('In Progress')"
                        mat-raised-button
                        class="btn btn-link btn-warning"
                        [ngClass]="{
                          borderselected: filtroMI == 'In Progress'
                        }"
                      >
                        <span class="material-icons"> inbox </span> In Progress
                        · {{ cant_in_progress }}
                      </button>
                    </div>
                    <div class="col-md-3 col-sm-4">
                      <button
                        (click)="filtrarMI('Completed')"
                        mat-raised-button
                        class="btn btn-link btn-success"
                        [ngClass]="{
                          borderselected: filtroMI == 'Completed'
                        }"
                      >
                        <span class="material-icons"> inbox </span>
                        Completed · {{ cant_completed }}
                      </button>
                    </div>
                  </div>
                </div>
                <div *ngFor="let item of itemsManifestNew" class="col-md-6">
                  <app-batch
                    [item]="item"
                    [whs_id]="whs_id"
                    (closeManifest)="getItemsManifest()"
                  ></app-batch>
                </div>
              </div>

              <!-- New Manifest Version Hector -->
            </div>
            <nav class="ml-3" aria-label="...">
              <ul class="pagination">
                <li
                  class="page-item"
                  [ngClass]="{
                    disabled: manifest_count_actual_page == 1
                  }"
                >
                  <a
                    class="page-link"
                    (click)="goPrevMI($event)"
                    href="#"
                    tabindex="-1"
                    >Previous</a
                  >
                </li>

                <li
                  class="page-item"
                  *ngFor="let p of pages"
                  [ngClass]="{
                    active: manifest_count_actual_page == p + 1
                  }"
                >
                  <a
                    (click)="gotoPageMI($event, p + 1)"
                    class="page-link"
                    href="#"
                    >{{ p + 1 }}
                    <span
                      *ngIf="manifest_count_actual_page == p + 1"
                      class="sr-only"
                      >(current)</span
                    >
                  </a>
                </li>

                <li
                  class="page-item"
                  (click)="goNextMI($event)"
                  [ngClass]="{
                    disabled: manifest_count_actual_page == pages.length + 1
                  }"
                >
                  <a class="page-link" href="#">Next</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <br /> -->
  <div
    *ngIf="
      action == 'read' &&
      !newManifest &&
      !newManifest2 &&
      !splitManifest &&
      deletManiest_id == null &&
      !erasure &&
      !changeStatus &&
      asignar == ''
    "
    class=""
    style="text-align: center"
  >
    <div class="" style="text-align: right">
      <div class="btn-group">
        <button
          type="button"
          class="btn btn-outline-info dropdown-toggle"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fa fa-columns" aria-hidden="true"></i>
        </button>
        <div class="dropdown-menu">
          <a
            class="dropdown-item pinter"
            *ngFor="let option of options"
            [ngClass]="{ visible: option.visibility }"
            (click)="option.visibility = !option.visibility; updateConfig()"
            >{{ option.colName }}</a
          >
        </div>
      </div>
    </div>
    <div class="" *ngIf="options.length">
      <nav class="nav nav-tabs justify-content-between">
        <div
          *ngIf="options[0].visibility"
          class="nav-item nav-link"
          [ngClass]="{ active: tab == 1 }"
          (click)="changeTab(1)"
        >
          <i class="material-icons">assignment</i> <br />
          <a>PO details</a>
        </div>
        <div
          *ngIf="options[1].visibility"
          class="nav-item nav-link"
          [ngClass]="{ active: tab == 2 }"
          (click)="changeTab(2)"
        >
          <i class="material-icons">local_shipping</i> <br />
          <a>Transportation details</a>
        </div>
        <div
          *ngIf="options[2].visibility"
          class="nav-item nav-link"
          [ngClass]="{ active: tab == 3 }"
          (click)="changeTab(3)"
        >
          <i class="material-icons">assignment_returned</i> <br />
          <a>Receiving PI</a>
        </div>
        <!--<div
                  *ngIf="options[3].visibility"
                  class="nav-item nav-link"
                  [ngClass]="{ active: tab == 4 }"
                  (click)="changeTab(4)"
                >
                  <i class="material-icons">view_list</i> <br />
                  <a>Manifesting PI</a>
                </div>-->
        <div
          *ngIf="options[4].visibility"
          class="nav-item nav-link"
          [ngClass]="{ active: tab == 5 }"
          (click)="changeTab(5)"
        >
          <i class="material-icons">playlist_add_check</i> <br />
          <a> Testing PI</a>
        </div>
        <!--<div
                  *ngIf="options[5].visibility"
                  class="nav-item nav-link"
                  [ngClass]="{ active: tab == 6 }"
                  (click)="changeTab(6)"
                >
                  <i class="material-icons">grading</i> <br />
                  <a>Data Sanitization</a>
                </div>
                <div
                  *ngIf="options[6].visibility"
                  class="nav-item nav-link"
                  [ngClass]="{ active: tab == 7 }"
                  (click)="changeTab(7)"
                >
                  <i class="material-icons">sell</i> <br />
                  <a>Sales PI</a>
                </div>-->
        <div
          *ngIf="options[7].visibility"
          class="nav-item nav-link"
          [ngClass]="{ active: tab == 8 }"
          (click)="changeTab(8)"
        >
          <i class="material-icons">fitness_center</i> <br />
          <a> Weights</a>
        </div>
        <div
          *ngIf="options[8].visibility"
          class="nav-item nav-link"
          [ngClass]="{ active: tab == 9 }"
          (click)="changeTab(9)"
        >
          <i class="material-icons">insert_drive_file</i> <br />
          <a
            ><span> Files</span>
            <span *ngIf="numFiles" class="badge top-right-red">{{
              numFiles
            }}</span>
          </a>
        </div>
        <div
          *ngIf="options[9].visibility"
          class="nav-item nav-link"
          [ngClass]="{ active: tab == 10 }"
          (click)="changeTab(10)"
        >
          <span *ngIf="chats.length" class="badge top-right-red">{{
            chats.length
          }}</span>
          <i class="material-icons">message</i> <br />
          <a>
            <span> Notes</span>
          </a>
        </div>
        <div
          *ngIf="options[10].visibility"
          class="nav-item nav-link"
          [ngClass]="{ active: tab == 11 }"
          (click)="changeTab(11)"
        >
          <i class="material-icons">sticky_note_2</i> <br />
          <a>Tickets</a>
        </div>
        <div
          *ngIf="options[11].visibility"
          class="nav-item nav-link"
          [ngClass]="{ active: tab == 12 }"
          (click)="changeTab(12)"
        >
          <i class="material-icons">notification_important</i> <br />

          <a> Reminders</a>
        </div>
      </nav>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="title-section">{{ title }}</h3>
      <!-- <button *ngIf="action == 'read'" type="button" class="btn btn-warning btn-md" (click)="action = 'update'">
                                          Edit
                                      </button>-->
    </div>
  </div>
  <br />
</div>
